import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingCurrency  {
    _originalTypeClassName = "zERP.BO.AccountingCurrency";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingCurrency.translate = translateService;
}
this.CurrencyID = null;
this.Name = null;
this.Symbol = null;
this.Abbreviation = null;
this.EuroRate = null;
this.isHomeCurrency = false;
this._key = this.CurrencyID = 0; 
}

static translate: TranslateService;
_key: any;
private _CurrencyID:any;
get CurrencyID(): any {
    return this._CurrencyID;
  }
set CurrencyID(value: any) {
    this._CurrencyID = value;
    this._key = value;
  }
Name:any;
Symbol:any;
Abbreviation:any;
EuroRate:any;
isHomeCurrency:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CurrencyID == null || $this.CurrencyID == 0;
            }


}